// extracted by mini-css-extract-plugin
export default {"main":"index_main_TSqsm","leftBox":"index_leftBox_4KFjx","rightBox":"index_rightBox_cqAEK","headerWrap":"index_headerWrap_KSRA2","footerWrap":"index_footerWrap_W8dno"};